import React from 'react';
import PropTypes from 'prop-types';
import ProductPriceItem, {
  productPriceItemTypes,
} from '@/components/productPriceItem';

function ShoppingCartDetails({ recurringPrices }) {
  return (
    <div className="product-price">
      {recurringPrices &&
        Array.isArray(recurringPrices) &&
        recurringPrices.length > 0 &&
        recurringPrices.map((product, productIndex) => {
          const key = `recurringPrices-${product.name}-${productIndex}`;
          const {
            name,
            finalPrice,
            promoted,
            promotionText,
            priceBeforeDiscount,
            quote,
            currency,
            oneTimePrices,
            info,
          } = { ...product };
          return (
            <div key={key}>
              <ProductPriceItem
                name={name}
                price={finalPrice}
                priceQuote={quote}
                priceCurrency={currency}
                promoted={promoted}
                promotionText={promotionText}
                promotionPrice={priceBeforeDiscount}
                type={productPriceItemTypes.detailRecurringPrice}
                info={info}
                cyData={key}
              />
              {oneTimePrices &&
                Array.isArray(oneTimePrices) &&
                oneTimePrices.length > 0 &&
                oneTimePrices.map((item, index) => {
                  const keyOneTimePrice = `oneTimePrices-${item.name}-${index}`;
                  const {
                    promoted: promotedOneTimePrice,
                    finalPrice: finalPriceOneTimePrice,
                    name: nameOneTimePrice,
                    promotionText: promotionTextOneTimePrice,
                    priceBeforeDiscount: priceBeforeDiscountOneTimePrice,
                    currency: currencyOneTimePrice,
                  } = item;
                  return (
                    <div key={keyOneTimePrice}>
                      <ProductPriceItem
                        name={promotedOneTimePrice ? '' : nameOneTimePrice}
                        price={priceBeforeDiscountOneTimePrice}
                        priceCurrency={currencyOneTimePrice}
                        promoted={promotedOneTimePrice}
                        promotionText={promotionTextOneTimePrice}
                        promotionPrice={finalPriceOneTimePrice}
                        type={productPriceItemTypes.detailOneTimePrice}
                        cyData={keyOneTimePrice}
                      />
                    </div>
                  );
                })}
            </div>
          );
        })}
      <style jsx>
        {`
          @import '../../styles/colors.scss';
          .product-price {
            display: flex;
            flex-direction: column;
          }
          .product-price > * {
            border-bottom: 1px solid $color-gp--grey2;
            padding-bottom: 8px;
            margin-bottom: 16px;
          }
          .product-price > *:last-child {
            border-bottom: none;
            padding-bottom: 0px;
            margin-bottom: 0px;
          }
        `}
      </style>
    </div>
  );
}
ShoppingCartDetails.propTypes = {
  recurringPrices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.number,
      promoted: PropTypes.bool,
      promotionText: PropTypes.string,
      promotionPrice: PropTypes.number,
      oneTimePrices: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          price: PropTypes.number,
          promoted: PropTypes.bool,
        })
      ),
    })
  ),
};

ShoppingCartDetails.defaultProps = {
  recurringPrices: [],
};
export default ShoppingCartDetails;
